import styled from 'styled-components';

export const Body = styled.div``;
export const Label = styled.span`
  font-family: Arial;
  font-size: 24px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #cfcfcf;
`;
